export class SystemContentModel {
    contentKey: string;
    contentName: string;
    contentVersion: string;
    contentText: string;
    createdTime: Date;

    constructor(data: any
    ) {
        this.contentKey = data.contentKey;
        this.contentName = data.contentName;
        this.contentVersion = data.contentVersion;
        this.contentText = data.contentText;
        this.createdTime = data.createdTime ? new Date(data.createdTime) : new Date();
    }

}